<template>
  <!-- 首頁用的基因條外殼（2026-10-04）：卡片捲到視窗前 300px 才放 GeneStrip 進來。
       GeneStrip 的圖被 scaleY(500) 拉長，邊界框大到從頁面任何位置都「跟視窗相交」，瀏覽器的 loading="lazy" 對它無效，
       放在靜態 HTML 裡會讓每條基因條在一進頁就把卡片原圖下載下來（首頁手機量到 11 張、4.9 MB）。外殼本身是正常大小，拿它來判斷遠近。
       預渲染不放（靜態 HTML 裡只有空殼，高度由外層 CSS 留好，CLS 0）。
       首頁的條用緊裁（tight → gene-strips.json 的 ts）：2026-10-04 19:00 哲宇看暗照片的條「像是壞掉」，連中間的大段暗區也裁掉。 -->
  <span ref="el" class="home-gene"><GeneStrip v-if="near" :slug="slug" :src="src" tight /></span>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import GeneStrip from '@/components/GeneStrip.vue'
import { isBot } from '@/runtime/view-transition'

defineProps({ slug: { type: String, required: true }, src: String })
const el = ref(null), near = ref(false)
let io = null
onMounted(() => {
  if (isBot() && typeof navigator !== 'undefined' && navigator.webdriver === true) return
  if (typeof IntersectionObserver !== 'function' || !el.value) { near.value = true; return }
  io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { near.value = true; io.disconnect(); io = null } }, { rootMargin: '300px 0px' })
  io.observe(el.value)
})
onBeforeUnmount(() => io?.disconnect())
</script>

<style>
.home-gene { display: block; height: var(--gene-h, 12px); }
</style>
